import React, { useState, useRef } from "react";
import Slider from "react-slick";
import { displayImage } from "../../helpers/config";
import { MdZoomOutMap } from "react-icons/md";
import { AnimatePresence } from "framer-motion";


function ProductImages({ images = ["", ""], callback }) {
    const [currentIndex, setcurrentIndex] = useState(0);
    const [imageLoading, setImageLoading] = useState(true)


    const SlideRef = useRef();

    const settings = {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        afterChange: (index) => setcurrentIndex(index),
    };

    const changeSlideImage = (index) => {
        setcurrentIndex(index);
        SlideRef.current.slickGoTo(index);
    };



    const settings1 = {
        slidesToShow: Math.min(4, images.length),
        slidesToScroll: Math.min(1, images.length),
        infinite: false,
        centerMode: false,
        initialSlide: 0,
        swipe: images.length > 4,        // Disable swipe if fewer images
        draggable: images.length > 4,
        arrows: images.length > 4,
        dots: false,
    };


    return (
        <div className="w-full relative">
            {/* Images */}
            <div className="flex flex-col gap-3 w-full lg:flex-row-reverse">
                {/* image */}
                <div className="w-full overflow-hidden rounded-xl flex-1 relative">
                    <Slider {...settings} ref={SlideRef}>
                        {images?.map((image, i) => (
                            <div key={i} className="overflow-hidden w-full cursor-pointer relative pt-[125%] rounded-xl">
                                <AnimatePresence>
                                    {imageLoading && (
                                        <div
                                            className="absolute z-50 w-full h-full top-0 left-0 right-0 bottom-0 animate-pulse bg-gradient-to-r from-gray-100 to-white" />
                                    )}
                                </AnimatePresence>
                                <img
                                    crossOrigin="anonymous"
                                    onLoad={() => setImageLoading(false)}
                                    src={displayImage(image)}
                                    loading="lazy"
                                    alt=""
                                    className="w-full h-full object-cover absolute 
                                        top-0 bottom-0 right-0 left-0 bg-white border-none"
                                />
                            </div>
                        ))}
                    </Slider>
                </div>

                {/* Thumnails */}
                <div className="lg:w-14 h-auto">

                    {/* For Large Screens */}
                    <div className="hidden lg:flex flex-col gap-2">
                        {images?.map((image, i) => (
                            <div
                                onClick={() => changeSlideImage(i)}
                                className={`cursor-pointer overflow-hidden rounded-lg border ${i === currentIndex && "border-black"
                                    }`}
                                key={i}
                            >
                                <img
                                    className="w-full"
                                    src={displayImage(image)}
                                    crossOrigin="anonymous" alt=""
                                    loading="lazy"
                                />

                            </div>
                        ))}
                    </div>

                    {/* For Small Screens */}
                    <div className="lg:hidden">
                        <Slider {...settings1} className="">
                            {images?.map((image, i) => (
                                <div
                                    onClick={() => changeSlideImage(i)}
                                    className={`cursor-pointer overflow-hidden w-full mr-2 block rounded-lg border ${i === currentIndex && "border-black"
                                        }`}
                                    key={i}
                                    style={{ marginRight: "20px" }}
                                >
                                    <img
                                        className="w-full"
                                        src={displayImage(image)}
                                        crossOrigin="anonymous" alt=""
                                        loading="lazy"
                                    />

                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>

            {/* Zoom */}
            <div className="absolute top-3 right-4">
                <button
                    onClick={() => callback()}
                    className="w-11 h-11 rounded-full bg-white flex items-center justify-center p-3"
                >
                    <MdZoomOutMap />
                </button>
            </div>
        </div>
    );
}

export default ProductImages;
